import React from "react";
import { Card, Col, Flex, Row, Typography, Button } from "antd";
import { Pie } from "react-chartjs-2";
import { FaArrowLeft, FaChartLine } from "react-icons/fa";

// Props Type
type Country = {
  name: string;
  color: string;
  value: string | number;
};

type ChartCardProps = {
  title: string;
  countries: Country[];
};

const pieData = {
  labels: ["أميركا", "اسبانيا", "كندا"],
  datasets: [
    {
      label: "نسبة البلدان",
      data: [45, 25, 30],
      backgroundColor: ["#00b894", "#fdcb6e", "#0984e3"],
      borderColor: "#fff",
      borderWidth: 2,
    },
  ],
};

const pieOptions = {
  responsive: false,
  maintainAspectRatio: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
};

const ChartCard: React.FC<ChartCardProps> = ({ title, countries }) => {
  const statStyle = {
    margin: 0,
    color: "#636e72",
  };

  return (
    <Card size="small">
      <Flex justify="space-between" style={{ marginBottom: 4 }}>
        <Flex vertical gap={2}>
          <Typography.Title level={5}>{title}</Typography.Title>
          <Flex gap={8} align="center">
            <Flex gap={4} align="center">
              <FaChartLine color="#00b894" />
              <Typography.Text style={{ color: "#00b894" }}>
                16.254.79
              </Typography.Text>
            </Flex>
            <div
              style={{
                background: "#0984e38a",
                padding: "4px",
                borderRadius: "5px",
                fontSize: 10,
                color: "#0984e3",
                fontWeight: "bold",
              }}
            >
              آخر أسبوع
            </div>
          </Flex>
        </Flex>
        <Button type="text">
          <Flex align="center" gap={6}>
            <Typography.Text style={{ color: "gray" }}>
              عرض الكل
            </Typography.Text>
            <FaArrowLeft size={10} color="gray" />
          </Flex>
        </Button>
      </Flex>

      <Pie
        data={pieData}
        height={200}
        width={200}
        options={pieOptions as any}
      />

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        {countries.map((country, index) => (
          <Col span={8} key={index}>
            <Flex gap={4}>
              <div
                style={{
                  width: 5,
                  height: 5,
                  backgroundColor: country.color,
                  borderRadius: "50%",
                  marginTop: 6,
                }}
              />
              <Flex vertical>
                <Typography.Text
                  style={{ color: "gray", margin: 0, lineHeight: "10px" }}
                >
                  {country.name}
                </Typography.Text>
                <Typography.Title level={4} style={statStyle}>
                  {country.value}
                </Typography.Title>
              </Flex>
            </Flex>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default ChartCard;
